export const APPLY_SUBSCRIPTION_ORDER = 'Subscriptions/APPLY_SUBSCRIPTION_ORDER';
export const RESET_SUBSCRIPTIONS_OPTION = 'Subscriptions/RESET_POSTAD_OPTION';
export const SET_LOADING = 'Subscriptions/SET_LOADING';
export const APPLY_SUBSCRIPTION_ORDER_FAILURE = 'Subscriptions/APPLY_SUBSCRIPTION_ORDER_FAILURE';
export const FETCH_SUBSCRIPTIONS = 'Subscriptions/FETCH_SUBSCRIPTIONS';